import { apiRequest } from './axiosConfig';

// 組織のメンバー全員で共有するバナーのタグ。色はサーバーが作成時に順番で割り当てる
export const IMAGE_TAG_COLORS = ['indigo', 'pink', 'teal', 'amber', 'purple', 'sky', 'rose', 'lime'] as const;
export type ImageTagColor = typeof IMAGE_TAG_COLORS[number];

export interface ImageTag {
  id: number;
  name: string;
  color: ImageTagColor;
}

export interface ImageTagAssignment {
  id: number;
  tags: ImageTag[];
}

interface TagListResponse {
  success: boolean;
  data: ImageTag[];
}

interface TagResponse {
  success: boolean;
  data: ImageTag;
}

interface AssignResponse {
  success: boolean;
  data: { images: ImageTagAssignment[] };
}

const imageTagService = {
  async list(): Promise<ImageTag[]> {
    const response = await apiRequest.get<TagListResponse>('image-tags');
    return response.data;
  },

  /** 同じ名前のタグが既にあれば、それが返る */
  async create(name: string): Promise<ImageTag> {
    const response = await apiRequest.post<TagResponse>('image-tags', { name });
    return response.data;
  },

  async update(id: number, changes: { name?: string; color?: ImageTagColor }): Promise<ImageTag> {
    const response = await apiRequest.patch<TagResponse>(`image-tags/${id}`, changes);
    return response.data;
  },

  async remove(id: number): Promise<void> {
    await apiRequest.delete(`image-tags/${id}`);
  },

  /** 複数のバナーにタグを付ける・外す。付いた結果のタグ一覧がバナーごとに返る */
  async assign(imageIds: number[], changes: { add?: number[]; remove?: number[] }): Promise<ImageTagAssignment[]> {
    const response = await apiRequest.post<AssignResponse>('images/tags', {
      image_ids: imageIds,
      add: changes.add ?? [],
      remove: changes.remove ?? [],
    });
    return response.data.images;
  },
};

export default imageTagService;
